module.exports = __webpack_public_path__ + "img/Globe1.c2f2529a.svg";